import { gsap } from "gsap";

export default function() {
  gsap.set(".js-fva-rainbow", {
    opacity: 0,
  });

  gsap.to(".js-fva-rainbow", {
    opacity: 1,
    delay: 2.5,
    duration: 2,
    ease: "power1.out"
  });
}
